import { queuesBasePath } from "@/react/features/vcc/urls";

class URLBuilder {
  constructor() {}

  /**
   * Builds the URL for retrieving the queues, taking media
   * types into consideration.
   *
   * Providing a null argument for media types will result in
   * a query fetching all queues, unfiltered.
   *
   * @param tenantName
   * @param mediaTypes - list of media types to fetch
   * @return {string} - GET url that provides desired queues
   * @constructor
   */
  GetQueuesByMediaTypes(tenantName, mediaTypes = null) {
    const baseUrl = queuesBasePath(tenantName);
    if (Array.isArray(mediaTypes) && mediaTypes?.length) {
      const params = new URLSearchParams();
      params.append("media_types", mediaTypes.join(","));
      return `${baseUrl}?${params.toString()}`;
    }

    return baseUrl;
  }

  DeleteQueues(tenantName) {
    return `${queuesBasePath(tenantName)}/delete`;
  }

  InboundQueues(tenantName) {
    return `${queuesBasePath(tenantName)}/inbound-phone`;
  }
}

export default new URLBuilder();
